import { render, staticRenderFns } from "./GroupNameAssignment.vue?vue&type=template&id=44364fc2&scoped=true"
import script from "./GroupNameAssignment.vue?vue&type=script&lang=js"
export * from "./GroupNameAssignment.vue?vue&type=script&lang=js"
import style0 from "./GroupNameAssignment.vue?vue&type=style&index=0&id=44364fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44364fc2",
  null
  
)

export default component.exports